import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {StatsCategoryApiModel} from "./stats-category.api-model";
import {OrderByPositionDomainModel} from "./orderByPosition/order-by-position.domain-model";
import {OrderByPositionApiModel} from "./orderByPosition/order-by-position.api-model";

export class StatsCategoryDomainModel extends BaseDomainModel {
  apiModel: StatsCategoryApiModel;

  get name(): String {
    return this.apiModel.name;
  }

  get orderLevel(): Number {
    return this.apiModel.orderLevel;
  }

  get orderByPosition(): Array<OrderByPositionDomainModel> {
    return this.apiModel.orderByPosition.map((position: OrderByPositionApiModel) => new OrderByPositionDomainModel(position));
  }
}